export default __webpack_public_path__ + "static/media/contact.29631760.svg";